module.exports = __webpack_public_path__ + "static/media/imselected.8f2e60d0.svg";